import React, { SyntheticEvent, useMemo } from 'react'
import Chip from '@mui/material/Chip'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { selectCommonUsers } from '../../../entities/Common'

interface SubscribersComboboxProps {
	subscribers: string[]
	handleSubscribersChange: (
		e: SyntheticEvent<Element, Event>,
		value: string[]
	) => void
}

export const SubscribersCombobox = (props: SubscribersComboboxProps) => {
	const { subscribers, handleSubscribersChange } = props
	const users = useAppSelector(selectCommonUsers)

	const options = useMemo(
		() => users.map((user) => `${user.email} (${user.fullName})`),
		[users]
	)


	return (
		<Autocomplete
			sx={{ mb: '1rem' }}
			multiple
			id="company-names"
			options={options}
			value={subscribers}
			onChange={handleSubscribersChange}
			renderTags={(value: string[], getTagProps) =>
				value.map((option, index: number) => (
					<Chip
						variant="filled"
						color="primary"
						label={option}
						{...getTagProps({ index })}
					/>
				))
			}
			renderInput={(params) => (
				<TextField
					{...params}
					variant="outlined"
					label="Managers*"
				/>
			)}
		/>
	)
}
